// Security validation functions to prevent XSS and injection attacks

export const sanitizeInput = (value) => {
  if (!value) return '';
  // Remove any HTML tags
  const div = document.createElement('div');
  div.textContent = value;
  let sanitized = div.textContent || div.innerText || '';
  
  // Remove encoded special characters that could be harmful
  sanitized = sanitized.replace(/&[#\w]+;/g, '');
  
  // Remove special characters except spaces, hyphens, and basic punctuation
  sanitized = sanitized.replace(/[<>"'%;)(&+]/g, '');
  
  return sanitized.trim();
};

export const validateName = (name) => {
  if (!name || name.trim().length === 0) return false;
  // Only allow letters, spaces, hyphens, and apostrophes
  const nameRegex = /^[a-zA-Z\s'-]+$/;
  return nameRegex.test(name.trim());
};

export const validateOrganization = (org) => {
  if (!org || org.trim().length === 0) return false;
  // Allow letters, numbers, spaces, hyphens, and basic punctuation
  const orgRegex = /^[a-zA-Z0-9\s.,'-]+$/;
  return orgRegex.test(org.trim());
};

export const validateEmail = (email) => {
  if (!email || email.trim().length === 0) return false;
  // Basic email validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email.trim());
};

export const validatePhone = (phone) => {
  if (!phone || phone.trim().length === 0) return false;
  // Allow numbers, spaces, hyphens, parentheses, and plus sign
  const phoneRegex = /^[\d\s\-+()]+$/;
  return phoneRegex.test(phone.trim());
};

export const validateMessage = (message) => {
  if (!message || message.trim().length === 0) return false;
  // Allow letters, numbers, spaces, and basic punctuation
  const messageRegex = /^[a-zA-Z0-9\s.,!?\-'"]+$/;
  return messageRegex.test(message.trim());
};

export const validatePassword = (password) => {
  if (!password || password.length < 6) return false;
  // Check for harmful characters
  const harmfulChars = /[<>"'%;)(&+]/;
  return !harmfulChars.test(password);
};
